// =============================================
// SERVICE: API de Não Conformidades
// =============================================

import { apiService } from './api';
import { buildApiUrl } from './config';

function buildUrlWithParams(path: string, params?: Record<string, unknown>): string {
  const url = buildApiUrl(path);
  if (!params) return url;
  const searchParams = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== null && value !== '') {
      searchParams.append(key, String(value));
    }
  }
  const qs = searchParams.toString();
  return qs ? `${url}?${qs}` : url;
}

export interface NaoConformidade {
  id: number;
  empresa_id: number;
  cliente_id?: number;
  conferencia_id?: number;
  tipo: string;
  severidade: 'info' | 'aviso' | 'critico';
  codigo_lido?: string;
  numero_palete?: number;
  descricao: string;
  dados_adicionais?: Record<string, unknown>;
  status: 'pendente' | 'analisando' | 'resolvido';
  resolvido_por?: number;
  resolvido_em?: string;
  observacoes?: string;
  cliente_razao_social?: string;
  resolvido_por_nome?: string;
  conferente_nome?: string;
  conferente_filial?: string;
  criado_em: string;
  atualizado_em: string;
}

export interface NaoConformidadeCreateData {
  cliente_id?: number;
  conferencia_id?: number;
  tipo: string;
  severidade?: 'info' | 'aviso' | 'critico';
  codigo_lido?: string;
  numero_palete?: number;
  descricao: string;
  dados_adicionais?: Record<string, unknown>;
}

export interface NaoConformidadeEstatisticas {
  total: number;
  por_status: {
    pendentes: number;
    analisando: number;
    resolvidos: number;
  };
  por_severidade: {
    info: number;
    avisos: number;
    criticos: number;
  };
  por_tipo: Array<{ tipo: string; total: number }>;
}

export async function listarNaoConformidades(params?: {
  page?: number;
  limit?: number;
  tipo?: string;
  status?: string;
  cliente_id?: number | string;
  data_inicio?: string;
  data_fim?: string;
  busca?: string;
  numero_pedido?: string;
}): Promise<{ success: boolean; naoConformidades: NaoConformidade[]; pagination: any }> {
  const url = buildUrlWithParams('/nao-conformidades', params as Record<string, unknown>);
  return apiService.request(url);
}

export async function buscarNaoConformidade(id: number): Promise<{ success: boolean; data: NaoConformidade }> {
  const url = buildApiUrl(`/nao-conformidades/${id}`);
  return apiService.request(url);
}

export async function criarNaoConformidade(data: NaoConformidadeCreateData): Promise<{ success: boolean; data: NaoConformidade }> {
  const url = buildApiUrl('/nao-conformidades');
  return apiService.request(url, {
    method: 'POST',
    body: JSON.stringify(data)
  });
}

export async function atualizarNaoConformidade(id: number, data: {
  status?: string;
  observacoes?: string;
}): Promise<{ success: boolean; data: NaoConformidade }> {
  const url = buildApiUrl(`/nao-conformidades/${id}`);
  return apiService.request(url, {
    method: 'PUT',
    body: JSON.stringify(data)
  });
}

export async function obterEstatisticasNaoConformidades(params?: {
  data_inicio?: string;
  data_fim?: string;
}): Promise<{ success: boolean; data: NaoConformidadeEstatisticas }> {
  const url = buildUrlWithParams('/nao-conformidades/estatisticas', params as Record<string, unknown>);
  return apiService.request(url);
}
